module.exports = __webpack_public_path__ + "static/media/aiva_appearance_image.42be33dc.png";